// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not_data_box[data-v-749f8693]{width:100%;height:100%;display:flex;flex:auto;flex-direction:column;justify-content:center;align-items:center}.not_data_box .not_data_img[data-v-749f8693]{width:2.08333rem;height:2.08333rem;margin-bottom:.20833rem}.not_data_box .not_msg[data-v-749f8693]{color:#333;font-size:.09722rem;margin-bottom:.13889rem}", ""]);
// Exports
module.exports = exports;
